import React from 'react';
import renderComposite from './compositeRows';
import StoresList from './StoresList';
import UsersList from './UsersList';

const renderCustomerRow = (definition, rowProps) => {
  if (definition.composite === 'stores')
    return <StoresList key={definition.key} stores={rowProps.value} />;
  if (definition.composite === 'users')
    return <UsersList key={definition.key} users={rowProps.value} />;
  return renderComposite(definition, rowProps);
};

export default renderCustomerRow;
